<template>
  <el-main class="page-content-margin-unset">
    <h3>品牌信息</h3>
    <div>
      <el-form
        :model="body"
        status-icon
        :rules="rules"
        label-position="left"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm">
        <el-form-item
          label="品牌名称"
          prop="name">
          <el-input
            class="dk-input"
            v-model="body.name"/>
        </el-form-item>
        <el-form-item
          label="排序"
          prop="priority">
          <el-input
            class="dk-input"
            v-model="body.priority"/>
        </el-form-item>
        <el-form-item
          label="品牌编号"
          prop="brand_no">
          <el-input
            class="dk-input"
            v-model="body.brand_no"/>
        </el-form-item>
        <el-form-item
          label="官网链接"
          prop="official_url">
          <el-input
            class="dk-input"
            v-model="body.official_url"/>
        </el-form-item>
        <el-form-item
          label="所属国家"
          prop="country">
          <el-input
            class="dk-input"
            v-model="body.country"/>
        </el-form-item>
        <el-form-item label="logo" prop="logo_src">
          <upload-img v-model="body" :prop="{ key: 'logo_src', url: 'logo_src_url' }" :label="'封面图'" />
          <label style="color: #666">注：建议长宽为40pt * 40pt</label>
        </el-form-item>
        <el-form-item label="背景图">
          <upload-img v-model="body" :prop="{ key: 'bg_src', url: 'bg_src_url' }" :label="'背景图'" />
          <label style="color: #666">注：建议长宽为375 * 212pt。</label>
        </el-form-item>
        <el-form-item label="视频">
          <upload-video ref="video" v-model="body" :prop="{ key: 'video_src', url: 'video_src_url' }" :label="'视频'" />
          <el-button type="danger"
                     icon="el-icon-delete"
                     @click="event().clearVideo()"
                     circle
                     style="position: absolute; top: 0px; left: 380px;">
          </el-button>
        </el-form-item>
        <el-form-item label="品牌介绍" prop="content">
          <el-input
            class="dk-input"
            type="textarea"
            v-model="body.content" />
        </el-form-item>
        <div class="table-top dk-li">
          <h3>线下旗舰店</h3>
        </div>
        <el-button style="float:right;" size="mini" type="primary"  @click="event().flagship_add()"> 新增 </el-button>
        <!-- 表格 -->
        <el-table
          border
          :data="body.flagship_list">
          <el-table-column label="*排序">
            <template slot-scope="scope" prop="priority">
              <el-input class="dk-input" v-model="scope.row.priority"/>
            </template>
          </el-table-column>
          <el-table-column label="*名称">
            <template slot-scope="scope">
              <el-input class="dk-input" v-model="scope.row.name"/>
            </template>
          </el-table-column>
          <el-table-column label="*城市">
            <template slot-scope="scope">
              <el-select v-model="scope.row.city" filterable placeholder="请选择">
                <el-option
                  v-for="item in cityList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="*区">
            <template slot-scope="scope">
              <el-select v-if="scope.row.city &&  cityList[scope.row.city]" v-model="scope.row.area" filterable placeholder="请选择">
                <el-option
                  v-for="item in cityList[scope.row.city].districts"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="*详细地址">
            <template slot-scope="scope">
              <el-input class="dk-input" v-model="scope.row.address"/>
            </template>
          </el-table-column>
          <el-table-column label="*电话">
            <template slot-scope="scope">
              <el-input class="dk-input" v-model="scope.row.tel"/>
            </template>
          </el-table-column>
          <el-table-column label="*营业时间">
            <template slot-scope="scope">
              <el-input class="dk-input" v-model="scope.row.business_house"/>
            </template>
          </el-table-column>
          <el-table-column label="*图片">
            <template slot-scope="scope">
              <upload-img v-model="scope.row" :prop="{ key: 'img_src', url: 'img_src_url' }" :label="'封面图'" />
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="220">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                class="mini-el-button"
                plain
                @click="event().flagship_del(scope.$index)">
                删 除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <label style="color: #666">注：图片建议长宽为327pt * 193pt。</label>

        <div class="table-top dk-li">
          <h3>产品目录</h3>
        </div>
        <el-button style="float:right;" size="mini" type="primary"  @click="event().catalog_add()"> 新增 </el-button>
        <!-- 表格 -->
        <el-table
          border
          :data="body.catalog_list">
          <el-table-column label="*目录">
            <template slot-scope="scope">
              <upload-file v-model="scope.row" :prop="{ key: 'catalog', file_name: 'catalog_file_name' }" :label="'目录'" />
            </template>
          </el-table-column>
          <el-table-column label="*图片">
            <template slot-scope="scope">
              <upload-img v-model="scope.row" :prop="{ key: 'catalog_img', url: 'catalog_img_url' }" :label="'封面图'" />
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="220">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                class="mini-el-button"
                plain
                @click="event().catalog_del(scope.$index)">
                删 除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <br ><br >
        <el-button @click="event().toBrackClick()">返 回</el-button>
        <el-button
          type="primary"
          @click="event().onSureClick('ruleForm')">保存</el-button>
      </el-form>
    </div>

  </el-main>
</template>

<script>
import { imgDomain, uploadDomain } from '../../configs/env'
import {
  addBrand as add_url, editBrand as edit_url, getBrandDetail as info_url, getCity
} from '../../api/content'

import uploadFile from '../../components/form/uploadFile'
import uploadImg from '../../components/form/uploadImg'
import uploadVideo from '../../components/form/uploadVideo'
export default {
  components: {
    uploadFile,
    uploadImg,
    uploadVideo,
  },
  data() {
    return {
      imgDomain,
      levelDialog: false,
      levelTitle: '添加规格',
      body: {
        product_no: '',
        name: '',
        official_url: '',
        priority: '',
        content: '',
        catalog_list: [],
        flagship_list: [],
        brand_no: '',
        video_src: '',
        video_src_url: '',
      },
      flagship_list: {
        name: '',
        price: '',
        img_src: '',
        priority: '',
        stock: '',
      },
      fristCategory: [],
      cityList: [],
      secondCategory: [],
      tableData: [],
      // 图片组件用的一些数据
      dialogImageUrl: '',
      dialogVisible: false,
      imglist: [],
      videoList: [],
      BrandList: [],
      detailList: [],
      flagship_listImgList: [],
      rules: {
        name: [
          { required: true, message: '请输品牌名称', trigger: 'blur' },
        ],
        priority: [
          { required: true, message: '请输入排序', trigger: 'blur' },
        ],
        brand_no: [
          { required: true, message: '请输入品牌编号', trigger: 'blur' },
        ],
        official_url: [
          { required: true, message: '请输入官网链接', trigger: 'blur' },
        ],
        country: [
          { required: true, message: '请输入所属国家', trigger: 'blur' },
        ],
        logo_src: [
          { required: true, message: '请添加封面图', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '请输入品牌介绍', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.network().getCity()
    if (!this.$route.query.uuid) return
    this.network().getCommodityDetail(this.$route.query.uuid)
  },
  methods: {
    event() {
      return {
        clearVideo: () => {
          this.$set(this.body, 'video_src')
        },
        toBrackClick: () => {
          this.$router.go(-1)
        },
        onSureClick: (formName) => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.handler().sure()
            } else {
              console.log('error submit!!');
            }
          });
        },
        onflagship_listSureClick: (formName) => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.handler().flagship_listSure()
            } else {
              console.log('error submit!!');
            }
          });
        },
        // 编辑/添加规格逻辑
        flagship_add: () => {
          this.levelDialog = false
          this.body.flagship_list.push({})
        },
        flagship_del: (index) => {
          if (this.body.flagship_list[index].uuid) {
            this.body.delete_flagship = [].concat(
              [this.body.flagship_list[index].uuid],
              this.body.delete_flagship ? this.body.delete_flagship : [],
            )
            this.body.flagship_list = this.body.flagship_list.filter(
              item => item.uuid !== this.body.flagship_list[index].uuid,
            )
          } else {
            this.body.flagship_list.splice(index, 1)
          }
        },
        // 编辑/添加规格逻辑
        catalog_add: () => {
          this.levelDialog = false
          this.body.catalog_list.push({})
        },
        catalog_del: (index) => {
          if (this.body.catalog_list[index].uuid) {
            this.body.delete_catalog = [].concat(
              [this.body.catalog_list[index].uuid],
              this.body.delete_catalog ? this.body.delete_catalog : [],
            )
            this.body.catalog_list = this.body.catalog_list.filter(
              item => item.uuid !== this.body.catalog_list[index].uuid,
            )
          } else {
            this.body.catalog_list.splice(index, 1)
          }
        },
      }
    },
    network() {
      return {
        getCity: async () => {
          const { status, data } = await getCity()
          if (status !== 200) return
          let cityList = {}
          for (let item of data) {
            for (let i of item.districts) {
              cityList[i.name] = i
            }
          }
          console.log(cityList)
          this.cityList = cityList
        },
        getCommodityDetail: async (body) => {
          const { status, data } = await info_url(body)
          if (status !== 200) return
          this.handler().commodityDetail(data.list)
        },
        addCommodity: async () => {
          const { status } = await add_url(this.body)
          if (status !== 200) return
          this.$notify({
            title: '新增成功',
            message: '新增品牌成功',
            type: 'success',
          });
          this.$router.go(-1)
        },
        editCommodity: async () => {
          const { status } = await edit_url(this.body)
          if (status !== 200) return
          this.$notify({
            title: '编辑成功',
            message: '编辑品牌成功',
            type: 'success',
          });
          this.$router.go(-1)
        },
      }
    },
    handler() {
      return {
        // 编辑/新增数据处理
        sure: () => {
          this.body.content = this.body.content
            .replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>')
            .replace(/\s/g, '&nbsp;')
          if (this.$route.query.uuid) {
            this.body.uuid = this.$route.query.uuid
            this.network().editCommodity()
            return
          }
          this.network().addCommodity()
        },
        commodityDetail: (data) => {
          data.logo_src = data.logo_src ? data.logo_src : ''
          data.bg_src = data.bg_src ? data.bg_src : ''
          data.video_src = data.video_src ? data.video_src : ''

          data.logo_src_url = data.logo_src ? this.imgDomain + data.logo_src : ''
          data.bg_src_url = data.bg_src ? this.imgDomain + data.bg_src : ''
          data.video_src_url = data.video_src ? this.imgDomain + data.video_src : ''
          data.flagship_list = data.flagship_list ? data.flagship_list : []
          data.flagship_list.forEach((item) => {
            item.img_src_url = this.imgDomain + item.img_src
          })
          data.content = data.content.replace(/&nbsp;/g, ' ').replace(/<br\/>/g, '\r\n')
          data.catalog_list = data.catalog_list ? data.catalog_list : []
          data.catalog_list.forEach((item) => {
            item.catalog_img_url = this.imgDomain + item.catalog_img
          })
          console.log(data)
          this.body = data
        },
      }
    },
    handleCurrentChange() {
    },
    // 放大
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/styles/mixins.scss';
.page-content-margin-unset{
  .dk-from{
    display: flex;
  }
  .table-top{
    @include dk-table-top;
  }
}
.cell .dk-input{
  width: 100%!important;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/brand/brand-add.vue